/**
 * 入力フォーム用JS
 */

import Lightpick from 'lightpick';
import 'lightpick/css/lightpick.css';
import moment from 'moment';
import YubinBango from 'yubinbango-core2';
import * as AutoKana from 'vanilla-autokana';

class FormEdit {
    constructor() {
        // 何かフォームフィールドにアクションを起こしたときだけ、
        // ページ離脱時に警告を出す
        this.doAction = false;
        // submit押したときは傾向を出さない
        this.isSubmit = false;

        /**************
         *  VARIABLES
         **************/
        if( document.getElementById('max_file_uploads') ){
            this.maxFilenum = document.getElementById('max_file_uploads').value;
        }
        if( document.getElementById('upload_max_filesize') ){
            this.maxFilesize = document.getElementById('upload_max_filesize').value;
        }
        if( document.getElementById('post_max_size') ){
            this.maxPostsize = document.getElementById('post_max_size').value;
        }
        if( document.getElementsByClassName('notification-for-js').length > 0 ){
            this.notify = document.getElementsByClassName('notification-for-js')[0];
            this.notifyTxt = this.notify.firstElementChild.firstElementChild;
        }

        /**************
         *  LISTENER
         **************/
        // フォームsubmitクリック
        this.submitBtnEls = Array.from(document.getElementsByClassName('submit-btn'));
        this.submitBtnEls.forEach(el => el.addEventListener('click', () => this.isSubmit = true));

        // フォーム戻るボタンクリック
        this.backBtnEls = Array.from(document.getElementsByClassName('back-btn'));
        this.backBtnEls.forEach(el => el.addEventListener('click', () => this.backToInputPage(el)));

        // フォームの色
        this.coloredEls = Array.from(document.querySelectorAll(`
            form.colored input[type=text],
            form.colored input[type=email],
            form.colored input[type=tel],
            form.colored input[type=password],
            form.colored textarea,
            form.colored select
        `));
        this.coloredEls.forEach(el => el.addEventListener('focus', () => el.style.backgroundColor = '#FFF'));
        this.coloredEls.forEach(el => el.addEventListener('blur', () => {
            if( !el.value ){
                el.style.backgroundColor = '#EFEFEF'
            }
        }));

        // フォーム入力必須バリデーション
        this.requiredEls = Array.from(document.querySelectorAll(`
            input[type=text].required,
            input[type=email].required,
            input[type=tel].required,
            input[type=password].required,
            textarea.required
        `));
        this.requiredEls.forEach(el => el.addEventListener('blur', () => this.validate(el)));

        // 自動で次に移動
        this.autoNextInputEls = Array.from(document.getElementsByClassName('auto-next-input'));
        this.autoNextInputEls.forEach(el => this.autoNextInput(el));

        // アップロードされた画像表示
        this.thumbnailEls = Array.from(document.getElementsByClassName('thumbnail'));
        this.thumbnailEls.forEach(el => el.addEventListener('change', ev => this.thumbnail(el, ev)));

        // 画像削除
        this.deleteImgEls = Array.from(document.getElementsByClassName('delete-img'));
        this.deleteImgEls.forEach(el => el.addEventListener('click', ev => this.deleteImg(el, ev)));

        // notify非表示
        this.notifyCloseEls = Array.from(document.getElementsByClassName('notify-close'));
        this.notifyCloseEls.forEach(el => el.addEventListener('click', ev => this.closeNotify(el)));

        // 文字数カウント
        this.countWordEls = Array.from(document.getElementsByClassName('count-word'));
        this.countWordEls.forEach(el => el.addEventListener('keyup', ev => this.countWord(el)));

        // 郵便番号から住所を入力
        this.zipEls = Array.from(document.getElementsByClassName('p-postal-code'));
        this.zipEls.forEach(el => el.addEventListener('keyup', ev => this.searchAddressByZip(el, ev)));

        // パスワード表示・非表示トグル
        this.togglePasswordDispEls = Array.from(document.getElementsByClassName('toggle-password-display'));
        this.togglePasswordDispEls.forEach(el => el.addEventListener('click', ev => this.togglePasswordDisplay(el)));

        // datepicker
        this.datepickerEls = Array.from(document.getElementsByClassName('datepicker'));
        this.datepickerEls.forEach(el => this.fireDatepicker(el));

        // WYSIWYGエディター
        this.wysiwygEls = Array.from(document.getElementsByClassName('wysiwyg'));
        this.wysiwygEls.forEach(el => this.fireWysiwyg(el));

        // カタカナ自動入力
        this.autoKana();

        // ページ初期化
        this.init();

        // フォームフィールドへのアクション検知
        this.detectAction();

        // ページ離脱を検知したら
        window.addEventListener('beforeunload', ev => this.leaveAlert(ev));
        window.addEventListener('unload', ev => this.leavePage(ev));
    }

    /**
     * ページ初期化時に実行
     */
    init(){
        // 文字数カウント
        this.countWordEls.forEach(el => this.countWord(el));

        // フォームの色
        this.coloredEls.forEach(el => {
            if( el.value ){
                el.style.backgroundColor = '#FFF';
            }
        });

        // バリデーションエラー表示
        let firstErr;
        document.querySelectorAll('.errMsg').forEach(el => {
            const nextEl = el.nextElementSibling;
            const prevEl = el.previousElementSibling;

            if( el.textContent != '' ){
                const nextOrPrevEl = nextEl ? nextEl : prevEl;

                if( !firstErr ) firstErr = el;
                if( nextOrPrevEl.tagName == 'INPUT' || nextOrPrevEl.tagName == 'TEXTAREA' || nextOrPrevEl.tagName == 'SELECT' ){
                    nextOrPrevEl.style.backgroundColor = '#FFDDDD';
                }else if( nextOrPrevEl.tagName == 'DIV' ){
                    Array.from(nextOrPrevEl.children).forEach(_el => {
                        if( _el.tagName == 'INPUT' || _el.tagName == 'TEXTAREA' || _el.tagName == 'SELECT' ){
                            _el.style.backgroundColor = '#FFDDDD';
                        }
                    });
                }
                if( nextEl ){
                    el.style.marginBottom = '10px';
                }else if( prevEl ){
                    el.style.marginTop = '10px';
                }
            }
        });

        if( firstErr ){
            firstErr.scrollIntoView({block: 'center'});
        }
    }

    /**
     * フォームフィールドにアクションを起こしたらdoActionを１にする
     */
    detectAction(){
        this.submitBtnEls.forEach(el => el.closest('form').querySelectorAll(`
            input[type=text], input[type=number], input[type=tel], input[type=email], input[type=password],
            input[type=checkbox], input[type=radio], input[type=file],
            textarea, select
        `).forEach(el2 => el2.addEventListener('change', () => this.doAction = true)));
    }

    /**
     * ページ離脱前
     */
    leaveAlert(ev){
        if( this.doAction && !this.isSubmit ){
            ev.preventDefault();
            ev.returnValue = 'check'; // 空文字以外何でも良い
        }
    }

    /**
     * ページ離脱後
     */
    leavePage(ev){
        if( this.doAction && !this.isSubmit ){
            // バリデーションエラー時にデータ保持のための
            // tmpディレクトリを削除
            const url = document.getElementById('tmp_delete_url').value;
            const formData = new FormData();
            formData.append('_token', document.querySelector('form [name=_token]').value);
            formData.append('tmp_upload_path', document.getElementById('tmp_upload_path').value);
            navigator.sendBeacon(url, formData);
        }
    }

    /**
     * 戻るボタンクリック
     */
    backToInputPage(el) {
        const formEl = el.closest('form');

        this.isSubmit = true;
        formEl.querySelector('[name=action]').value = 'back';
        formEl.submit();
    }

    /**
     * 入力チェック
     */
    validate(el){
        let textIsEmpty = false;
        let errorMsgEl;

        // エラーメッセージ表示用エレメントを探す
        if( el.previousElementSibling && el.previousElementSibling.classList.contains('errMsg') ){
            errorMsgEl = el.previousElementSibling;
            textIsEmpty = el.value ? false : true;
        }else if( el.closest('ul') && el.closest('ul').previousElementSibling.classList.contains('errMsg') ){
            errorMsgEl = el.closest('ul').previousElementSibling;
            textIsEmpty = Array.from(el.closest('ul').querySelectorAll('input, textarea')).find(_el => _el.value == '');
        }else if( el.closest('div') && el.closest('div').previousElementSibling.classList.contains('errMsg') ){
            errorMsgEl = el.closest('div').previousElementSibling;
            textIsEmpty = Array.from(el.closest('div').querySelectorAll('input, textarea')).find(_el => _el.value == '');
        }

        // エラーメッセージ表示用エレメントがあったら
        if( errorMsgEl ){
            if( textIsEmpty ) {
                errorMsgEl.style.marginBottom = '10px';
                errorMsgEl.textContent = !errorMsgEl.textContent ? '入力してください。' : errorMsgEl.textContent;
            }else{
                errorMsgEl.style.marginBottom = 0;
                errorMsgEl.textContent = '';
            }
        }

        // 入力要素の背景色変化
        if( el.value == '') {
            el.style.backgroundColor = '#FFDDDD';
        }else{
            el.style.backgroundColor = '#FFF';
        }
    }

    /**
     * 次の入力に自動focus
     */
    autoNextInput(el){
        const maxlength = el.getAttribute('maxlength');
        if( !maxlength ) return false;

        el.addEventListener('keyup', () => {
            if( el.value.length >= maxlength ){
                document.getElementById(el.dataset.nextTarget).focus();
            }
        });
    }

    /**
     * サムネイル表示
     */
    async thumbnail(el, event) {
        // エラ〜メッセージ初期化
        this.notifyTxt.textContent = '';
        this.notify.firstElementChild.classList.remove('error', 'success');
        this.notify.style.display = 'none';

        if( event.target.files && event.target.files[0] ){

            try{
                if( el.files[0].size > this.maxFilesize) {
                    throw new Error('ファイルのサイズが大きすぎます。（最大ファイルサイズ: '+ (this.maxFilesize/(1024*1024)) +' MB）');
                }

                let totalSize = 0;
                this.thumbnailEls.forEach(_el => {
                    if( _el.files.length < 1 ) return; // continueの動き

                    totalSize += _el.files[0].size;
                    if( totalSize > this.maxPostsize ){
                        throw new Error('ファイルのサイズが大きすぎます。（合計ファイルサイズ: '+ (this.maxPostsize/(1024*1024)) +' MBまで)');
                    }
                });

                // バリデーションエラー時にデータ保持のため
                // tmpディレクトリに保存
                const url = document.getElementById('tmp_upload_url').value;
                const formData = new FormData();
                formData.append('file', event.target.files[0]);
                formData.append('_token', el.closest('form').querySelector('[name=_token]').value);
                formData.append('tmp_upload_path', document.getElementById('tmp_upload_path').value);

                const response = await fetch(url, {
                    method: 'POST',
                    body: formData
                });
                const result = await response.json();

                if( result.status == 'error' ){
                    throw new Error(result.message);
                }
                // tmpディレクトリに保存した情報をHTMLに書き込み
                const _tmp_path = document.getElementsByName(el.name.replace('_file', '_tmp_path'))[0];
                const _tmp_name = document.getElementsByName(el.name.replace('_file', '_tmp_name'))[0];
                const _url = document.getElementsByName(el.name.replace('_file', '_url'))[0];
                document.getElementById('tmp_upload_path').value = result.path;
                _tmp_path.value = result.path;
                _tmp_name.value = result.name;
                _url.value = result.url;

                // サムネイル表示
                const reader = new FileReader();
                const img = document.getElementById(el.dataset.target);
                const _now = document.getElementsByName(el.name.replace('_file', ''))[0];

                reader.onload = ev => {
                    img.setAttribute('src', ev.target.result);
                    img.parentNode.style.display = 'block';
                    _now.value = 'new';
                };
                reader.readAsDataURL(event.target.files[0]);

            }catch( error ){
                this.notifyTxt.textContent = error.message;
                this.notify.firstElementChild.classList.add('error');
                this.notify.style.display = 'flex';
                el.value = '';
                el.files = null;
                return false;
            }
        }
    }

    /**
     * 画像削除
     */
    deleteImg(el, ev) {
        ev.preventDefault();

        const imgEl = el.previousElementSibling;
        const wrapEl = el.parentNode;
        const urlEl = el.parentNode.parentNode.parentNode.querySelector('[name$="_url"]');
        const nowName = urlEl.name.replace('_url', '');
        const nowEl = el.parentNode.parentNode.parentNode.querySelector('[name='+nowName+']');
        const fileEl = el.parentNode.parentNode.parentNode.querySelector('.thumbnail');

        imgEl.src = '';
        wrapEl.style.display = 'none';
        urlEl.value = '';
        nowEl.value = '';
        fileEl.value = '';
    }

    /**
     * notify非表示　
     */
    closeNotify(el) {
        el.closest('.notification-for-js').style.display = 'none';
    }

    /**
     * 文字数カウント
     */
    countWord(el) {
        const spanEl = document.querySelector(el.dataset.target);
        spanEl.textContent = el.value.length;
    }

    /**
     * 郵便番号から住所検索
     */
    searchAddressByZip(el, ev) {
        new YubinBango.Core(el.value, function(addr) {
            const formEl = el.closest('.h-adr');
            if( formEl.querySelector('select.p-region') ){
                formEl.querySelector('select.p-region').value = addr.region_id;
            }
            if( formEl.querySelector('input.p-region') ){
                formEl.querySelector('input.p-region').value = addr.region;
            }
            if( formEl.querySelector('.p-locality') ){
                formEl.querySelector('.p-locality').value += addr.locality;
            }
            if( formEl.querySelector('.p-street-address') ){
                formEl.querySelector('.p-street-address').value += addr.street;
            }
            if( formEl.querySelector('.p-extended-address') ){
                formEl.querySelector('.p-extended-address').value += addr.extended;
            }
        });
    }

    /**
     * datepickerを表示する
     */
    fireDatepicker(el){
        new Lightpick({
            field: el,
            lang: 'ja',
            format: 'YYYY年MM月DD日',
            minDate: moment().format('YYYY年MM月DD日')
        });
    }

    /**
     * パスワードの表示・非表示を切り替える
     */
    togglePasswordDisplay(el) {
        if( el.previousElementSibling.type == 'password' ){
            el.previousElementSibling.type = 'text';
            el.children[0].classList.remove('fa-eye');
            el.children[0].classList.add('fa-eye-slash');
        }else{
            el.previousElementSibling.type = 'password';
            el.children[0].classList.remove('fa-eye-slash');
            el.children[0].classList.add('fa-eye');
        }
    }

    /**
     * カナ自動入力
     */
    autoKana() {
        const autoKanaEls = document.querySelectorAll('.auto-kana');
        if( autoKanaEls.length > 0 ){
            autoKanaEls.forEach(el => {
                const targetEl = document.getElementById(el.dataset.kana);
                if( targetEl ){
                    AutoKana.bind('#'+el.id, '#'+targetEl.id, { katakana: true });

                    el.addEventListener('blur', () => {
                        // kanaのほうの色変更
                        if( targetEl.value == '') {
                            targetEl.style.backgroundColor = '#EFEFEF';
                        }else{
                            targetEl.style.backgroundColor = '#FFF';
                        }
                    });

                }
            });
        }
    }
}

const formEdit = new FormEdit();
